import React from 'react';
import ReactModal from 'react-modal';
import {useAuth} from "../../../hooks/useAuth";
import useLoading from '../../../hooks/useLoading';


import useAppRouter from "../../../hooks/useAppRouter";


interface LogoutConfirmModalProps {
  onSubmitted: (isClose: boolean) => Promise<void>;
}

export const LogoutConfirmModal = (props: LogoutConfirmModalProps) => {
  const { onSubmitted } = props;
  const { state: { currentUser }, logout } = useAuth();

  const withLoading = useLoading();
  const { gotoTopByUser } = useAppRouter();


  const onCancel = async () => {
    gotoTopByUser();
  };

  const onLogout = async () => {
    withLoading(logout);

    onSubmitted(true);
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        // onRequestClose={() => onSubmitted(false)}
        className="w-1/3"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
        style={{
          content: {
            position: 'fixed',
            top: '1rem'
          }
        }}
      >
        <section className="modal-background">
          <div className="form-modal-container">
            <div className="form-modal-title">
              <h1 className="font-semibold">確認</h1>
            </div>
            <div className="form-modal-content">

              <div className="text-primary text-sm font-semibold grid grid-cols-1 w-full break-all">
                <p>
                  現在、{ currentUser?.name }（{ currentUser?.email }）でログインされています。
                </p>
                <p>アカウント作成を行う場合は、ログアウトしてください。</p>
              </div>
            
            </div>
            <div className="form-modal-footer-container">
              <div className="form-modal-footer">
                <button
                  className="btn-sub"
                  type="button"
                  onClick={() => onCancel()}
                >
                  TOPページへ戻る
                </button>
                <button
                  className="btn-primary"
                  type="button"
                  onClick={() => onLogout()}
                >
                  ログアウト
                </button>
                
              </div>
            </div>
          </div>
        </section>
      </ReactModal>
    </>
  );
}